import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="callback-contain">
        回调
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/oauth/callback/index.js